import fetch from 'isomorphic-fetch'
import { getParam } from '../../helpers/parameters'

export const apiFetchStartContent = async (
  currentPhoneId,
  preSaleFlag,
  language,
  customer
) => {
  const suggestedContentApiUrl = await getParam('suggestedContentApiUrl')
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  return fetch(
    `${suggestedContentApiUrl}/swimlane?language=${language}&phone=${currentPhoneId}&customer=${customer}&count=4${preSaleURL}`
  ).then(req => req.json())
}



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/services.js